import { CommonService } from './../../../../shared/services/common.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { TransferOrderService } from '../../../../shared/services/transfer-order.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-transfer-order-list',
  templateUrl: './transfer-order-list.component.html'
})
export class TransferOrderListComponent implements OnInit {
  loading: boolean = true;
  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    profileId: '',
    designationId: '',
    stateId: '',
    districtId: '',
    schoolId: '',
    shalaId: ''
  };

  columns = [
    { title: 'Sr.No.', key: 'ProfileId', isSortable: false },
    { title: 'Name', key: 'ProfileId', isSortable: false },
    { title: 'From Designation', key: 'FromDesignationId', isSortable: false },
    { title: 'From School/Place', key: 'FromSchoolId', isSortable: false },
    { title: 'To Designation', key: 'ToDesignationId', isSortable: false },
    { title: 'To School/Place', key: 'ToSchoolId', isSortable: false },
    {}
  ];

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: TransferOrderService,
    private commonService: CommonService) {
  }

  ngOnInit() {
    this.bindDropDown();
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.profileId = params.profileId ? params.profileId : '';
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.regionId = params.regionId ? params.regionId : '';
        this.query.stateId = params.stateId ? params.stateId : '';
        this.query.districtId = params.districtId ? params.districtId : '';
        this.query.schoolId = params.schoolId ? params.schoolId : '';
        this.query.shalaId = params.shalaId ? params.shalaId : '';
        this.populateTransferOrders();
        this.bindCascadeDropdown();
      });
  }

  private populateTransferOrders() {
    this.loading = true;
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      }, (err) => console.log(err),
        () => this.loading = false);                    
  }    


  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
  }

  bindCascadeDropdown() {
    if (this.query.regionId) {
      this.getStates(this.query.regionId);
    }
    if (this.query.stateId) {
      this.getDistricts(this.query.stateId);
    }
    if (this.query.districtId) {
      this.getSchools(this.query.districtId);
    }
  }


  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number) {
    this.commonService.getSchools(districtId, 1).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/management/transfer-orders'], {
      queryParams: this.query
    });
  }

  filter() {
    this.query.page = 1;
    this.router.navigate(['/management/transfer-orders'], {
      queryParams:  this.query
    });
  }

  
  export() {
    this.service.export().subscribe((data) => {
      const blob = new Blob([data], { type: 'application/pdf' });
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "transfer-orders.pdf";
      link.click();
    });
  }
}
